<template>
  <div class="green-circle" v-if="showMeCurrent">
    <div v-html="$translate('Phywe::Template.greenBubbleSavingText')"></div>
    {{ ((showMeCurrent.singlePrice.default.price.value * currentItem.variation.unitsContained) - currentItem.prices.default.price.value).toFixed(2) | currency  }}
    <br>
    ({{ showMeCurrent.ersparnisProzent }}%)
  </div>
</template>

<script>

export default
{
  props:
  {
    vars:
    {
      type: Object,
      default: () => {}
    }
  },
  inject:
  {
    itemId:
        {
          default: null
        }
  },
  data: function()
  {
    return {
      variations:null
    }
  },
  created:function()
  {
    let _self = this;
    _self.variations = _self.vars;
    this.greencircle();
  },
  methods:
  {
    currentVariation: function()
    {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
    greencircle:function()
    {
      let _self = this;

      for (let i = 0; i < _self.variations.pack.length; i++)
      {
        for (let o = 0; o < _self.variations.single.length; o++)
        {
          // o is einzelpreis
          if (_self.variations.single[o].data.attributes[0].valueId == _self.variations.pack[i].data.attributes[0].valueId && _self.variations.single[o].data.unit.unitOfMeasurement != 'PK') {
            _self.variations.pack[i].singlePrice = _self.variations.single[o].data.prices;

            let einzelpreispack = parseFloat(_self.variations.pack[i].data.prices.default.price.value) / parseFloat(_self.variations.pack[i].data.variation.unitsContained);
            //console.log('einzelpreispack'+einzelpreispack);

            let einzelpreissingle = _self.variations.single[o].data.prices.default.price.value;
            //console.log('einzelpreissingle'+einzelpreissingle);

            let diff = einzelpreissingle - einzelpreispack;
            //console.log('diff'+diff);

            let prozentunsauber = (100 / einzelpreissingle) * diff;
            //console.log('prozentunsauber'+prozentunsauber);

            _self.variations.pack[i].ersparnisProzent = prozentunsauber.toFixed(0);
          }
        }
      }
    }
  },
  computed:
  {
    showMeCurrent:function ()
    {
      let vars    = this.variations;
      let current = this.currentVariation();
      let showCurrent = null;
      if(vars != null)
      {
        for(let i = 0; i < vars.pack.length; i++)
        {
          if(vars.pack[i].id === current.variation.id)
          {
            showCurrent = vars.pack[i];
          }
        }
      }
      return showCurrent;
    },
    currentItem:function()
    {
      return this.currentVariation();
    }
  }
}
</script>
